import { AlphaVCircleOutlineIcon } from './AlphaVCircleOutlineIcon';

/**
 * author: Contributors
 * id F6CE363B-41A6-411A-9FDE-D36E24013012
 * name alpha-v-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-v-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterVCircleOutlineIcon = AlphaVCircleOutlineIcon;
export default LetterVCircleOutlineIcon